import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupOrganizationsList } from '@shared/api/lib/group/group';
import {
  GroupOrganizationsListParams,
  PaginatedGroupOrganizationListList,
} from '@shared/api/types';

/**
 * Paginated list of child organizations under the requesting parent org.
 * Drives the Organizations table on the group dashboard.
 */
export const useGetGroupOrganizations = (
  params?: GroupOrganizationsListParams
) =>
  useGroupOrganizationsList<PaginatedGroupOrganizationListList>(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
    },
  });
